import IconButton from '@liquidweb-dev/undercurrent/IconButton';
import InfoIcon from '@liquidweb-dev/undercurrent/icons/lucide/Info';
import Stack, { StackProps } from '@liquidweb-dev/undercurrent/Stack';
import Tooltip from '@liquidweb-dev/undercurrent/Tooltip';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

import HookedSwitch from 'components/standard/Form/HookedSwitch';

const Autorenew = ({ sx, ...rest }: StackProps) => (
	<Stack sx={combineSx({ gap: 100 }, sx)} {...rest}>
		<Stack
			sx={{
				flexDirection: 'row',
				gap: 100,
				alignItems: 'center',
			}}
		>
			<Typography variant="body-sm" sx={{ fontWeight: 500 }}>
				Renewal
			</Typography>
			<Tooltip
				variant="fancy"
				title="How does it work?"
				arrow
				message="Renews 45 days before expiration for the same duration as initial order"
			>
				<IconButton size="small" variant="barebones">
					<InfoIcon
						sx={({ vars }) => ({
							color: vars.palette.uc.icon.weak,
						})}
					/>
				</IconButton>
			</Tooltip>
		</Stack>

		<HookedSwitch
			name="autorenew"
			label="Autorenew certificate"
			color="highlight"
		/>
	</Stack>
);

export default Autorenew;
